import React from "react";
import {
  Row,
  Col,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { capitalize } from "../util/view";
import Button from "reactstrap/lib/Button";
import { Link } from "react-router-dom";

const SpotListItem = ({ spot, openEditModal, ...props }) => {
  return (
    <ListGroupItem className="spot-list-item">
      <Row noGutters>
        <Col xs={11}>
          <Link to={`/spot/${spot.id}`}>
            <ListGroupItemHeading>{capitalize(spot.name)}</ListGroupItemHeading>
          </Link>
          <ListGroupItemText>{spot.description}</ListGroupItemText>
        </Col>

        <Col xs={1}>
          <span className="align-middle">
            <Button color="link">
              <FontAwesomeIcon
                onClick={() => openEditModal(spot.id)}
                icon={faEdit}
              />
            </Button>
          </span>
        </Col>
      </Row>
    </ListGroupItem>
  );
};

export default SpotListItem;
